"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProgramGuide = (function () {
    function ProgramGuide() {
        var _this = this;
        this.offsetToday = 0;
        this.rangePrevious = 3;
        this.rangeNext = 3;
        this.programGuideWrapper = document.querySelector(".program-guide-wrapper");
        this.getData(this.offsetToday, this.rangePrevious, this.rangeNext);
        document
            .querySelector(".previous")
            .addEventListener("click", function () { return _this.previousDay(); });
        document
            .querySelector(".next")
            .addEventListener("click", function () { return _this.nextDay(); });
    }
    ProgramGuide.getInstance = function () {
        if (!this.instance) {
            this.instance = new ProgramGuide();
        }
        return this.instance;
    };
    ProgramGuide.prototype.getData = function (offsetToday, rangePrevious, rangeNext) {
        var _this = this;
        this.programGuideWrapper.classList.add("loading");
        return fetch("/guide?offsetToday=" + offsetToday + "&rangePrevious=" + rangePrevious + "&rangeNext=" + rangeNext + "&usePlaceholders=true", {
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            }
        })
            .then(function (response) { return response.json(); })
            .then(function (response) { return _this.renderSlots(response); });
    };
    ProgramGuide.prototype.renderSlots = function (data) {
        this.programGuide = document.querySelector("#program-guide");
        this.programGuide.innerHTML = "";
        if (data) {
            for (var i = 0; i < data.days.length; i++) {
                if (data.days[i].noBroadcast) {
                    this.renderPlaceholder(data.days[i]);
                }
                else {
                    this.renderDay(data.days[i]);
                }
            }
        }
        else {
            this.programGuideWrapper.insertAdjacentHTML("beforeend", "<div class=\"load-error\">Something went wrong, please try again later</div>");
        }
        this.programGuideWrapper.classList.remove("loading");
        this.setGuideHeight();
    };
    ProgramGuide.prototype.renderDay = function (day) {
        this.programGuide.insertAdjacentHTML("beforeend", "<section " + (day.today ? 'class="current"' : "") + "> \n                <header>\n                    <span>" + day.date + "</span>\n                    <span>" + (day.today ? "vandaag" : day.day) + "</span>\n                </header>\n                " + day.programs
            .map(function (program) {
            return "<a href=\"" + program.url + "\" class=\"program " + (program.playing ? "live" : "") + "\" style=\"--data-slot-size: " + program.slots + ";\">\n                                <span><time>" + program.time + "</time> u</span>\n                                <p>" + program.title + "</p>\n                                <span class=\"play-button launch-player data-type=\"live\">\n                                    <span class=\"icon\"><span class=\"icon-play\"></span></span>\n                                </span>\n                            </a>";
        })
            .join("") + "\n            </section>");
    };
    ProgramGuide.prototype.renderPlaceholder = function (placeholder) {
        this.programGuide.insertAdjacentHTML("beforeend", "<section " + (placeholder.today ? 'class="current"' : "") + "> \n                <header>\n                    <span>" + placeholder.date + "</span>\n                    <span>" + (placeholder.today ? "vandaag" : placeholder.day) + "</span>\n                </header>\n                <span class=\"program no-broadcastdata\" style=\"--data-slot-size: 48\" ><span>" + placeholder.programs[0].title + "</span></span>\n            </section>");
    };
    ProgramGuide.prototype.setGuideHeight = function () {
        var sections = document.querySelectorAll("#program-guide section");
        var sectionHeight = [];
        for (var i = 0; i < sections.length; i++) {
            sectionHeight.push(sections[i].clientHeight);
        }
        var visibleSection = sections[3];
        this.programGuide.setAttribute("style", "height:" + (window.innerWidth <= 350
            ? visibleSection.clientHeight
            : Math.max.apply(Math, sectionHeight)) + "px");
    };
    ProgramGuide.prototype.previousDay = function () {
        this.offsetToday--;
        this.getData(this.offsetToday, this.rangePrevious, this.rangeNext);
    };
    ProgramGuide.prototype.nextDay = function () {
        this.offsetToday++;
        this.getData(this.offsetToday, this.rangePrevious, this.rangeNext);
    };
    return ProgramGuide;
}());
exports.default = ProgramGuide;
